import { COUNTRY } from './country'

export const ACHIEVEMENTS_ENABLED = COUNTRY === 'kg'
export const PROMOCODES_ENABLED = COUNTRY === 'kg'
